import { IEntity } from "./ientity";
import { IDisable } from "./idisable";
import { ICountry } from "./icountry";
import { IMetaDataItemDetail } from "./imetadetailitem";

export interface IItemConfigSet {
    countryDataId: number;
    businessFunctionId: number;
    country: ICountry;
    itemConfigs: ItemConfigBase[];
    statusId: number;
    comments: string;
    isCorrection: boolean;
}

export interface IItemConfigSetEditable extends IItemConfigSet {
    canSaveAndCancel: boolean;
    canEdit: boolean;
}

export interface IItemConfig extends IEntity, IDisable {
    $type: string;
    name: string;
    displayText: string;
    parentId: number;
    sortOrder: number;
    businessFunctionId: number;
    lastUpdatedText: string;
    itemDetail: IItemDetail;
    children: IItemConfig[];
    itemConfigType: ItemConfigTypes;
}

export enum ItemConfigTypes {
    CategoryItemConfig = 1,
    HtmlTextItemConfig = 2,
    DateItemConfig = 3,
    DropdownItemConfig = 4
}

export class ItemConfigBase implements IItemConfig {
    $type: string;
    id: number;
    name: string;
    displayText: string;
    parentId: number;
    sortOrder: number;
    businessFunctionId: number;
    lastUpdatedText: string;
    itemDetail: IItemDetail;
    children: ItemConfigBase[];
    disabled: boolean;
    itemConfigType: ItemConfigTypes;

    constructor(
        type: string,
        name: string,
        parentId: number,
        disabled: boolean) {
        this.$type = type;
        this.name = name;
        this.children = [];
        this.parentId = parentId;
        this.disabled = disabled;
    }
}

export class HtmlItemConfig extends ItemConfigBase {
    constructor(
        name: string,
        parentId: number,
        disabled: boolean) {
        super("MultiJurisdictionCms.Dto.Items.HtmlTextItemConfigDto, MultiJurisdictionCms.Dto", name, parentId, disabled);
        this.itemConfigType = ItemConfigTypes.HtmlTextItemConfig;
    }
}

export class CategoryItemConfig extends ItemConfigBase {
    constructor(
        name: string,
        parentId: number,
        disabled: boolean) {
        super("MultiJurisdictionCms.Dto.Items.CategoryItemConfigDto, MultiJurisdictionCms.Dto", name, parentId, disabled);
        this.itemConfigType = ItemConfigTypes.CategoryItemConfig;
    }
}

export class DateItemConfig extends ItemConfigBase {
    constructor(
        name: string,
        parentId: number,
        disabled: boolean) {
        super("MultiJurisdictionCms.Dto.Items.DateItemConfigDto, MultiJurisdictionCms.Dto", name, parentId, disabled);
        this.itemConfigType = ItemConfigTypes.DateItemConfig;
    }
}

export class DropdownItemConfig extends ItemConfigBase {
    dropdownId: number;
    allowMultiple: boolean;
    constructor(
        name: string,
        parentId: number,
        disabled: boolean) {
        super("MultiJurisdictionCms.Dto.Items.DropdownItemConfigDto, MultiJurisdictionCms.Dto", name, parentId, disabled);
        this.itemConfigType = ItemConfigTypes.DropdownItemConfig;
    }
}

export interface IItemDetail extends IEntity {
    countryId: number;
    itemConfigId: number;
    metadataItemDetails: IMetaDataItemDetail[];
    value: string;
    codes: string;
    modified: boolean;
    hasHistory: boolean;
    updatedDate: Date;
}